// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2H1-B","consentsList":"PatientConsents_consentsList__TtdkP","consentsListEmpty":"PatientConsents_consentsListEmpty__2jTHD"};